import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "../thema/style";
import AddCartButton from "./AddCartButton";
import { Link } from "react-router-dom";
import { PUBLIC_URL } from "../config";
import LazyImage from "./shared/LazyImage";
import { generateAltText } from "../helpers/seo";

class ProductItem extends Component {
  constructor(props) {
    super(props);
    this.img = React.createRef();
  }

  render() {
    return (
      <div className={this.props.itemSize}>
        <div className={styles.productItem}>
          <div ref={this.thumb} className={"product-thumb"}>
            <div className={"product-thumb-detail"}>
              <Link
                to={{
                  pathname: `/urun/${this.props.slug}`,
                  state: { product: this.props }
                }}
                title={`${this.props.name} - Detayları görüntüle`}
                aria-label={`${this.props.name} ürününün detay sayfasını aç`}
              >
                <span>
                  <FontAwesomeIcon icon={["fas", "search"]} color={"#fff"} />
                </span>
              </Link>
            </div>
            <LazyImage
              alt={generateAltText('product', this.props)}
              title={`${this.props.name} - Botaniksan'da satın al`}
              ref={this.img}
              src={PUBLIC_URL(this.props.image)}
              placeholderColor="#f8f9fa"
              fit="contain"
              style={{
                width: "100%",
                height: "260px",
                backgroundColor: "#fff",
              }}
              imgStyle={{ width: "100%", height: "100%" }}
            />
          </div>
          <div className={"product-info"}>
            <Link
              to={{
                pathname: `/urun/${this.props.slug}`,
                state: { product: this.props }
              }}
              title={`${this.props.name} - Ürün detayları`}
              aria-label={`${this.props.name} ürününün detay sayfasına git`}
            >
              <h3 className={"product-title"}>{this.props.name}</h3>
            </Link>
            <div className={"product-price"}>
              {this.props.sale_price ? (
                <React.Fragment>
                  <span className={"old-price"}>₺{this.props.price}</span>
                  <span className={"special-price"}>
                    ₺{this.props.sale_price}
                  </span>
                </React.Fragment>
              ) : (
                <span className={"special-price"}>₺{this.props.price}</span>
              )}
            </div>
            <div className={"product-extra-link"}>
              <AddCartButton img={this.img} product={this.props} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProductItem.defaultProps = {
  itemSize: "col-md-3"
};

export default ProductItem;
// const mapStateToProps = ({}) => {
//   return {};
// };
//
// const mapDispatchToProps = { setProduct };
//
// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(ProductItem);



// WEBPACK FOOTER //
// ./src/components/ProductItem.js